import { TextareaControl, TextareaControlProps } from "formik-chakra-ui";
import React from "react";

export const TextareaWithValidationControl: React.FC<TextareaControlProps> = (
  props
) => {
  return <TextareaControl {...props} errorMessageProps={{ height: "1rem" }} />;
};
